<importer-sub-header title="AMPERE Workaround"></importer-sub-header>

<div class="sub-nav-bar">
  <coin-v2-button
    [type]="openList === 'transfer' ? 'primary' : 'secondary'"
    [text]="'Transfer List'"
    [icon]="'chevron_right'"
    [iconPos]="'right'"
    (click)="openTransferListPage()"></coin-v2-button>

  <coin-v2-button
    [type]="openList === 'structure' ? 'primary' : 'secondary'"
    [text]="'Structure List'"
    [icon]="'chevron_right'"
    [iconPos]="'right'"
    (click)="openStructureListPage()"></coin-v2-button>

  <coin-v2-button
    [type]="openList === 'email' ? 'primary' : 'secondary'"
    [text]="'Email List'"
    [icon]="'chevron_right'"
    [iconPos]="'right'"
    (click)="openEmailListPage()"></coin-v2-button>
</div>

@if (openList === 'transfer') {
  <importer-transfer-list></importer-transfer-list>
}
@if (openList === 'structure') {
  <importer-structure-list></importer-structure-list>
}
@if (openList === 'email') {
  <importer-email-list></importer-email-list>
}
